import HttpClient from "./http-client";

export default class ExtraPayService {
  #client;

  constructor(token) {
    this.#client = HttpClient({ token });
  }

  async getCardByUser(username) {
    const response = await this.#client.get(`/extrapay/getcardbyuser/${username}`);

    return response.data;
  }

  async getConversionsByUser(username) {
    const response = await this.#client.get(`/extrapay/getconversionbyuser/${username}`);

    return response.data;
  }

  async convertUserWalletValue(payload) {
    const response = await this.#client.post(`/extrapay/convert`, payload);

    return response.data;
  }

  async getWalletPointsBalance() {
    const response = await this.#client.get("/extrapay/walletpoints/balance");

    return response.data;
  }

  async getCycleCount(username) {
    const response = await this.#client.get(`/extrapay/walletpoints/countcycle/${username}`);

    return response.data;
  }

  async getOrdersInCycle(username) {
    const response = await this.#client.get(
      `/extrapay/walletpoints/countordersincycle/${username}`,
    );

    return response.data;
  }

  async getWalletTokensBalance() {
    const response = await this.#client.get("/extrapay/wallettokens/balance");

    return response.data;
  }

  async listWithdrawalsByUser(username) {
    const response = await this.#client.get(
      `/extrapay/wallettokens/withdraw/listbyuser/${username}`,
    );

    return response.data;
  }

  async requestWithdrawal(payload) {
    const response = await this.#client.post("/extrapay/wallettokens/withdraw/request", payload);

    return response.data;
  }

  async listAllWithdrawals(usernameadmin) {
    const response = await this.#client.get(
      `/extrapay/wallettokens/withdraw/listall/${usernameadmin}`,
    );

    return response.data;
  }

  async processWithdrawal(payload) {
    const response = await this.#client.post("/extrapay/wallettokens/withdraw/process", payload);

    return response.data;
  }
}


